import RestApiModel from "@/api/Model/RestApiModel";

class CoverholderOrderSubmission extends RestApiModel {
  static getResourceEndpoint() {
    return '/CoverholderOrderSubmission';
  }
}

export default CoverholderOrderSubmission;
